'use client'

import { useNotifications } from '@/services/notifications'
import { useAuthStore } from '@/stores/auth'

/**
 * Hook to get unread notification count
 *
 * NOTE: This hook is used by multiple components (GlobalHeader, Navigation, etc.)
 * The welcome toast logic has been moved to WelcomeNotificationToast component
 * to avoid duplicate toasts from multiple hook instances.
 */
export function useNotificationCount() {
  const { isAuthenticated } = useAuthStore()
  const { data } = useNotifications()

  // Get unread count from first page
  const unreadCount = data?.pages[0]?.unreadCount ?? 0

  return isAuthenticated ? unreadCount : 0
}
